import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from 'assets/jss/material-dashboard-react';

const dashboardStyle = {
  successText: {
    color: successColor[0],
  },
  styleNoPaddingRight: {
    paddingRight: '0!important',
  },
  upArrowCardCategory: {
    width: '16px',
    height: '16px',
  },
  stats: {
    color: grayColor[0],
    display: 'inline-flex',
    fontSize: '12px',
    lineHeight: '22px',
    '& svg': {
      top: '4px',
      width: '16px',
      height: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      top: '4px',
      fontSize: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
  },
  cardCategory: {
    fontWeight: '400',
    color: grayColor[0],
    margin: '0',
    fontSize: '18px',
    marginTop: '0',
    paddingTop: '0',
    marginBottom: '0',
  },
  cardCategoryWhite: {
    color: `rgba(${hexToRgb(whiteColor)},.62)`,
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '600',
    marginBottom: '0px',
    fontSize: '30px',
    textDecoration: 'none',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
  cardBackground: {
    background: '#F5F9FA',
    minHeight: '94px',
    justifyContent: 'center',
    border: 'none',
  },
  cardBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  cardIcon: {
    marginRight: '10px',
  },
  cardProjectsMargin: {
    marginLeft: '25px',
  },

};

export default dashboardStyle;
